import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("poc_lang") || "id");

  useEffect(() => {
    localStorage.setItem("poc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const value = path.split(".").reduce((obj, key) => (obj ? obj[key] : undefined), translations[lang]);
    return value !== undefined ? value : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
